<template>
	<div class="md-layout">
		<simple-datatable
			title="Liste des secteurs"
			:add="add"
			editRoute="Edit Sector"
			:data="sectors"
			:footer="['#', 'Nom', '']"
			:searchFields="['id', 'name']"
			defaultSort="id"
		></simple-datatable>
	</div>
</template>

<script>
import SimpleDatatable from "@/pages/Configuration/components/SimpleDatatable";

export default {
	name: "Sectors",
	components: {
		SimpleDatatable
	},
	data() {
		return {
			sectors: [],
			add: {
				text: "Ajouter un secteur",
				route: "Add Sector"
			},
		}
	},
	async mounted() {
		let { data } = await this.$store.dispatch('sectors/getSectors')
		this.sectors = data
	}
}
</script>

<style scoped>

</style>
